import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { RedirectToLogout, PrivateRoute, RedirectToLogin, ImpersonationOverlay } from '../lib/auth'
import { Error } from '@pga/pga-component-library'
import { PaymentFailure, NoInvoicesFound } from '../components/ErrorBoundary/ErrorMessages'
import { AppContainer } from './App.styles'
import Header from '../components/Header'
import Success from '../components/Success/Success'
import ProxyRequest from '../components/ProxyRequest'
import StripeContainer from '../components/StripeContainer'
import Footer from '../components/Footer'

const App = ({ history }) => {
  const RETURN_TO_URL = `${process.env.REACT_APP_AUTH_RETURN_TO}/${history.location.search}`

  return (
    <AppContainer>
      <ImpersonationOverlay />
      <Header />
      <Switch>
        <PrivateRoute exact path='/proxy-request' component={ProxyRequest} />
        <PrivateRoute exact path='/logout' component={RedirectToLogout} />
        <Route exact path='/success' component={Success} />
        <Route exact path='/login' render={() => <RedirectToLogin returnTo={RETURN_TO_URL} />} />
        <Route exact path='/error' render={() => <Error Message={PaymentFailure} />} />
        <Route exact path='/no-invoices' render={() => <Error Message={NoInvoicesFound} />} />
        <Route path='*' component={StripeContainer} />
      </Switch>
      <Footer />
    </AppContainer>
  )
}

export default withRouter(App)
